import React from 'react';
import { injectIntl } from 'react-intl';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import Crop75Icon from '@mui/icons-material/Crop75';
import { STUDIO_FORMATS } from '../../../constants';

interface FormatControlProps {
  intl: any;
  format: string;
  onChangeFormat: (format: string) => void;
}

const FormatControl: React.FC<FormatControlProps> = ({ intl, format, onChangeFormat }) => (
  <ToggleButtonGroup
    color="primary"
    value={format}
    exclusive
    fullWidth
    onChange={(_event, value: string | null) => value && onChangeFormat(value)}
  >
    {Object.values(STUDIO_FORMATS).map(option => (
      <ToggleButton key={option.id} value={option.id} className="studio-format-button">
        {option.id === 'story' ? <CropPortraitIcon /> : <Crop75Icon />}
        <span>
          <Typography variant="caption" component="span">
            {intl.formatMessage({ id: option.labelId })}
          </Typography>
          <Typography variant="caption" component="small">
            {option.ratio}
          </Typography>
        </span>
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default injectIntl(FormatControl);
